import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
    selector: 'app-publish-save-button',
    templateUrl: './publish-save-button.component.html',
    standalone: false
})
export class PublishSaveButtonComponent extends AppBaseComponent {
  @Input() label: string;
  @Input() tooltip: string;
  @Input() isPrimaryBtn: boolean;
  @Output() triggered = new EventEmitter<void>();
  
  onClick(): void {
    this.triggered.emit();
  }
}
